/**
 * Ascentix Dev wordmark — clean, modern executive typographic mark.
 * Uses Cabinet Grotesk for "Ascentix" and a lighter weight for "Dev".
 * Includes a subtle ascending peak SVG glyph in Ascentix orange.
 */
export default function Wordmark({
  size = "md",
  invert = false,
  showSubtitle = false,
}) {
  const scale =
    size === "sm"
      ? "text-[18px]"
      : size === "lg"
      ? "text-[28px]"
      : "text-[22px]";
  const peakSize =
    size === "sm" ? "size-5" : size === "lg" ? "size-8" : "size-6";

  const ink = invert ? "text-amber-50" : "text-slate-900";
  const sub = invert ? "text-amber-200/70" : "text-slate-500";

  return (
    <div className="inline-flex items-center gap-2.5">
      <span className={`${peakSize} relative shrink-0`} aria-hidden="true">
        <svg viewBox="0 0 32 32" className="w-full h-full">
          <defs>
            <linearGradient id="wm-grad" x1="0" y1="1" x2="0" y2="0">
              <stop offset="0%" stopColor="#f59e0b" />
              <stop offset="100%" stopColor="#ea580c" />
            </linearGradient>
          </defs>
          <polygon points="16,3 30,29 2,29" fill="url(#wm-grad)" opacity="0.22" />
          <polygon points="16,9 26,29 6,29" fill="url(#wm-grad)" opacity="0.45" />
          <polygon points="16,15 22,29 10,29" fill="url(#wm-grad)" />
        </svg>
      </span>
      <span className="leading-none flex flex-col">
        <span
          className={`font-display ${scale} ${ink} tracking-[-0.02em]`}
        >
          Ascentix<span className="text-orange-600">Dev</span>
        </span>
        {showSubtitle && (
          <span className={`mt-1 text-[11px] uppercase tracking-[0.22em] ${sub}`}>
            Development Limited
          </span>
        )}
      </span>
    </div>
  );
}
